import { AppOldDefaultNavigationState } from '../../../initialStateRegistration';

export const getHeaderWithSubMenus = (state: AppOldDefaultNavigationState) => state.headerWithSubMenus;
